/**
 * Habit Service
 * API client for daily habit tracking
 */

import { apiClient, extractData } from './api';
import type { HabitWithStatus, HabitStreakData, CheckInResult, Habit } from '@kids-lms/types';

/** Get all habits + today's completion status */
async function getHabits(childId: string): Promise<HabitWithStatus[]> {
  const response = await apiClient.get(`/habits/${childId}`);
  return extractData(response);
}

/** Add a new habit */
async function addHabit(childId: string, name: string, emoji: string): Promise<HabitWithStatus> {
  const response = await apiClient.post(`/habits/${childId}`, { name, emoji });
  return extractData(response);
}

/** Edit a habit */
async function updateHabit(habitId: string, data: { name?: string; emoji?: string }): Promise<Habit> {
  const response = await apiClient.put(`/habits/${habitId}`, data);
  return extractData(response);
}

/** Remove a habit (soft-delete) */
async function deleteHabit(habitId: string): Promise<void> {
  await apiClient.delete(`/habits/${habitId}`);
}

/** Toggle a habit done/undone today */
async function checkIn(childId: string, habitId: string, completed: boolean): Promise<CheckInResult> {
  const response = await apiClient.post(`/habits/${childId}/check-in`, { habitId, completed });
  return extractData(response);
}

/** Get streak + points data */
async function getStreaks(childId: string): Promise<HabitStreakData> {
  const response = await apiClient.get(`/habits/${childId}/streaks`);
  return extractData(response);
}

const habitService = {
  getHabits,
  addHabit,
  updateHabit,
  deleteHabit,
  checkIn,
  getStreaks,
};

export default habitService;
